export default function ({ set }, indices) {
    return (indices.length !== count(set)) ? false : indices.every(i => set[i].correct === true);
}

function count(set){
    var k = 0;
    for(let i = 0; i < set.length; i++){
        if(set[i].correct === true){
            k++;
        }
    }
    return k;
}
